<div class="create-certificate" *transloco="let t; read:'permit.team.createCertificate'">
    <form [formGroup]="form">
        <div class="create-certificate__content">
            <div class="create-certificate__content__heading">{{ t("title") }}</div>
                <div class="create-certificate__content__form__heading" [innerHTML]="t('concept')"></div>
                <ha-select  #role [label]="t('chooseConcept')" [options]="concepts" formControlName="concept" (ngModelChange)="onChange($event)">
                </ha-select>
                <hr class="create-certificate__content__form__divider" />

                <ng-container *ngIf="form.get('email') !== null">
                    <div class="create-certificate__content__form__heading" [innerHTML]="t('email')"></div>
                    <ha-input name="email" formControlName="email" class="create-certificate__content__form__input" [label]="t('email')"></ha-input>
                    <hr class="create-certificate__content__form__divider" />
                </ng-container>

                <ng-container *ngIf="getCurrentActiveConcept() != ConceptType.Denmark">
                    <div class="create-certificate__content__form__heading" [innerHTML]="t('certificateIdentifierLabel.' + getCurrentActiveConcept())"></div>
                    <ha-input name="certificateIdentifier" formControlName="certificateIdentifier" class="create-certificate__content__form__input" [label]="t('certificateIdentifier.' + getCurrentActiveConcept())"></ha-input>
                    <div *ngIf="getCurrentActiveConcept() == ConceptType.BrandfarligaArbeten" (click)="openCertificateIdentifierHintModal($event)" class="create-certificate__content__form__message" [innerHtml]="t('certificateIdentifierHint')"></div>
                    <hr class="create-certificate__content__form__divider" />
                </ng-container>

                <div class="create-certificate__content__form__heading" [innerHTML]="t('certificateExpiryDate')"></div>
                <ha-input type="date" name="expirationDate" formControlName="expirationDate" class="create-certificate__form__input" [label]="t('dateLabel')" [max]="maxDate" [min]="minDate">
                </ha-input>

                <validation-messages *ngIf="(createCertificateResponse$ | async)" read="permit.team.createCertificate" [form]="form"
                                     [validationResult]="(createCertificateResponse$ | async)?.validationResult"></validation-messages>
        </div>
    </form>
</div>
